export default "__VITE_ASSET__vMC4c$ek__"